import React, { useEffect, useMemo, useState } from "react";
import { loader } from "graphql.macro";
import { useQuery } from "../../../hooks/useQuery";
import { TournamentBoard } from "./TournamentBoard";
import { TournamentRounds } from "./TournamentRounds";
import {
  TableOperation,
  TournamentPlayerPerTeam,
  TournamentStatus,
  TournamentType,
} from "../../../graphql/generated";
import { useLocation, useParams } from "react-router";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useSubscription } from "../../../hooks/useSubscription";
import {
  InstantTournamentSubscription,
  InstantTournamentSubscriptionVariables,
} from "./graphql/InstantTournamentSubscription.generated";
import {
  InstantTournamentQuery,
  InstantTournamentQueryVariables,
} from "./graphql/CurrentInstantTournamentQuery.generated";

const INSTANT_TOURNAMENT_QUERY = loader(
  "./graphql/CurrentInstantTournamentQuery.graphql"
);

const INSTANT_TOURNAMENT_SUBSCRIPTION = loader(
  "./graphql/InstantTournamentSubscription.graphql"
);

export const CurrentInstantTournaments = () => {
  const { sectionId, tournamentId } = useParams<{
    sectionId: string;
    tournamentId: string;
  }>();
  const { push } = useHistory();

  const [
    tournamentStatus,
    setTournamentStatus,
  ] = useState<TournamentStatus | null>();

  const variables = useMemo(() => {
    return { id: tournamentId };
  }, [tournamentId]);

  const filterData = React.useMemo(() => {
    return {
      roomId: sectionId?.split(":")[0],
      gameId: sectionId?.split(":")[1],
    };
  }, [sectionId]);

  const [{ data, fetching, error }] = useQuery<
    InstantTournamentQuery,
    InstantTournamentQueryVariables
  >({
    query: INSTANT_TOURNAMENT_QUERY,
    variables,
    throwOnError: false,
    requestPolicy: "network-only",
  });

  useEffect(() => {
    if (!fetching && error) {
      push(`/area/${filterData?.roomId}:${filterData.gameId}/my-tournaments`);
    }
  }, [fetching, error]);

  const [{ data: subscriptionData }] = useSubscription<
    unknown,
    InstantTournamentSubscription,
    InstantTournamentSubscriptionVariables
  >({
    query: INSTANT_TOURNAMENT_SUBSCRIPTION,
    variables: {
      id: tournamentId,
    },
    throwOnError: false,
  });

  useEffect(() => {
    if (subscriptionData) {
      if (
        subscriptionData.instantTournament?.__typename ===
        "InstantTournamentEntityUpdate"
      ) {
        const tournament = subscriptionData?.instantTournament?.tournament;

        setTournamentStatus(tournament?.status!);
      }
    }
  }, [subscriptionData]);

  useEffect(() => {
    if (data?.instantTournament)
      setTournamentStatus(data?.instantTournament?.status);
  }, [data]);

  const handleCloseShowTournament = () => {
    push(`/area/${filterData?.roomId}:${filterData.gameId}/my-tournaments`);
  };

  if (tournamentId) {
    if (
      tournamentStatus === TournamentStatus.Upcoming ||
      tournamentStatus === TournamentStatus.Draw
    ) {
      return (
        <TournamentBoard
          onClose={handleCloseShowTournament}
          tournamentId={tournamentId}
          roomId={filterData.roomId}
        />
      );
    }
    if (
      tournamentStatus === TournamentStatus.Ongoing ||
      tournamentStatus === TournamentStatus.Completed
    ) {
      return (
        <TournamentRounds
          onClose={handleCloseShowTournament}
          tournamentId={tournamentId}
          roomId={filterData.roomId}
        />
      );
    }
    if (tournamentStatus === TournamentStatus.Cancelled) {
      return (
        <Redirect
          to={`/area/${filterData?.roomId}:${filterData.gameId}/my-tournaments`}
        />
      );
    }
  }

  return <></>;
};
